import React from 'react';
import GuestInput from './components/guest-input/index';
import Label from "storybookComponents/EditableLabel"
import './style.css';
import SelectField from "./components/PopoverRSVP/selectField"
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from "components/InputField"


const getSelectedValues = (formFields, fields) => {
  if (fields.length === 0) {
    return []
  }
  let initialValues = [];
  for (let i = 0; i < fields.length; i++) {
    let fieldDetails = fields[i].split('_');
    let _fields = formFields.find(e => e.fieldId === fieldDetails[0])
    if (_fields) {
      initialValues.push({
        fieldDetails: _fields,
        required: fieldDetails[1] === "required" ? true : false
      })
    }
  }
  return initialValues
}


const InputField = (props) => {
  const onBlur = (evt) => {
    if (typeof props.handleBlur === "function") {
      if (props.keyName)
        props.handleBlur(props.keyName, evt.target.value)
      else
        props.handleBlur(evt.target.value)
    }
  }
  return (<div className={`hyly-input-field`}>
    <TextField {...props} onBlur={onBlur} />
  </div>)
}

const JoinUsForm = ({ classes, values, setFieldValue, popoverId, hylyFormFields }) => {
  const [selectedFields, setSelectedFields] = React.useState(getSelectedValues(hylyFormFields, values.leadFields))

  React.useEffect(() => {
    setSelectedFields(getSelectedValues(hylyFormFields, values.leadFields))
  }, [values.leadFields])

  const renderSelectedFields = (value, index) => {
    const { fieldDetails, required } = value;
    if (fieldDetails.fieldOptions.length === 0) {
      return <InputField classes={classes} key={fieldDetails.label} label={`${fieldDetails.label} ${required ? "*" : ''}`} keyName={fieldDetails.label} />
    } else {
      return <FormControl classes={{
        root: classes.formMargin
      }}>
        <InputLabel id="demo-simple-select-label" className={classes.labelIndex}>{fieldDetails.label} {required && "*"}</InputLabel>
        <SelectField options={fieldDetails.fieldOptions} value=""
          customValues={{
            width: 400,
            mainWidth: 410,
            background: "#f9f9f9",
            marginBottom: 10,
            disableUnderline: true
          }} />
      </FormControl>
    }

  }
  return (
    <div className={`${classes.rsvpFormContainer} hyly-rsvp-form`}>
      <div className="rsvp-title">
        <Label id="joinUsInput" className={classes.joinUsClass} keyName="rsvpFormHeader" handleBlur={setFieldValue} color="darkBlack" text={values.rsvpFormHeader} />
      </div>
      <InputField classes={classes} label="First Name*" value={values.firstName} keyName="name" />
      <InputField classes={classes} label="Last Name*" value={values.lastName} keyName="name" />
      <InputField classes={classes} label="Email*" value={values.email} keyName="email" />
      <InputField classes={classes} label="Phone Number*" value={values.phone} keyName="phone" />
      <GuestInput setFieldValue={setFieldValue} {...values} popoverId={popoverId} />
      {
        selectedFields && selectedFields.map(renderSelectedFields)
      }
      <br />
      <Label text={values.ctaText} keyName="ctaText" handleBlur={setFieldValue} containerClasses={classes.rsvpFieldContainer} iconClasses={classes.whiteIcon} className={classes.rsvpField} />
    </div>
  )
}

export default JoinUsForm

